<template>
  <div
    :class="{ 'form-group--error' : errors.has('email') }"
    class="form-group">
    <div
      v-if="response"
      :class="[isValidEmail ? 'notice--success': 'notice--danger']"
      class="notice u-margin-bottom-s">
      <div class="notice__content u-align-center">
        <p>{{ response.data.message }}</p>
      </div>
    </div>
    <div class="input-group">
      <input
        v-model="model.email"
        v-validate="'required|email'"
        name="email"
        type="text"
        class="input u-border-radius-left"
        placeholder="johndoe@gmail.com"
        @keyup.enter="submit">
      <button
        :disabled="loading || errors.has('email')"
        class="button u-border-radius-right"
        @click.prevent="submit">
        <span class="button__text">{{ loading ? 'Validating' : 'Validate Email' }}</span>
        <button-loader v-if="loading"/>
      </button>
    </div>
    <span class="help-text"><strong>Give it a quick try</strong>. Type in an email address for validation.</span>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    loading: false,
    response: null,
    model: {
      email: null
    }
  }),
  computed: {
    isValidEmail () {
      return this.response.data.status
    }
  },
  methods: {
    async submit () {
      const validator = await this.$validator.validateAll()

      if (validator) {
        this.loading = true

        this.response = await axios.post(this.route('validate-email'), this.model)

        this.loading = false
      }
    }
  }
}
</script>
